export type ServiceCategoryId =
  | 'all'
  | 'athletic'
  | 'artistic'
  | 'general'
  | 'college';

export type ServicePriceRangeId = 'all' | 'low' | 'medium' | 'high';
export type ServiceSortId = 'recommended' | 'nameAsc' | 'priceLowHigh' | 'priceHighLow';

export interface ServiceCategory {
  id: ServiceCategoryId;
  name: string;
  icon: string;
  iconFile?: string;
}

export interface ServiceListing {
  _id: string;
  providerUserId: string;
  providerName: string;
  providerProfilePicture?: string;
  previewImageUrl?: string;
  title: string;
  serviceKind: Exclude<ServiceCategoryId, 'all'>;
  serviceKindLabel: string;
  summary: string;
  price?: string;
  location?: string;
  availability?: string;
  tags: string[];
  organizationName?: string;
  contactName?: string;
  opportunityType?: string;
  eligibility?: string;
  deadline?: string;
  learnMoreUrl?: string;
}

export interface ServicePriceRangeOption {
  id: ServicePriceRangeId;
  label: string;
}

export interface ServiceSortOption {
  id: ServiceSortId;
  label: string;
}

export const SERVICES_PER_PAGE = 15;

export const SERVICE_CATEGORIES: ServiceCategory[] = [
  {id: 'all', name: 'All Services', icon: '🎯', iconFile: 'view-cozy.svg'},
  {id: 'athletic', name: 'Athletic Services', icon: '⚽', iconFile: 'running-shoes.svg'},
  {id: 'artistic', name: 'Artistic Services', icon: '🎨', iconFile: 'art-fill.svg'},
  {id: 'general', name: 'General Services', icon: '🧰', iconFile: 'general-service.svg'},
  {id: 'college', name: 'College/University Services', icon: '🏫', iconFile: 'university-solid.svg'},
];

export const SERVICE_PRICE_RANGE_OPTIONS: ServicePriceRangeOption[] = [
  {id: 'all', label: 'All Prices'},
  {id: 'low', label: 'Under $50'},
  {id: 'medium', label: '$50 - $100'},
  {id: 'high', label: '$100+'},
];

export const SERVICE_SORT_OPTIONS: ServiceSortOption[] = [
  {id: 'recommended', label: 'Recommended'},
  {id: 'nameAsc', label: 'Name A-Z'},
  {id: 'priceLowHigh', label: 'Price: Low to High'},
  {id: 'priceHighLow', label: 'Price: High to Low'},
];
